import React from "react";
import SnpBaseLayout from "../../global/SnpBaseLayout";
import useUiController from "../../global/hooks/useUiController";
import RestoKeyboardQuickBill from "./RestoKeyboardQuickBill";

const RestoKeyboardBase = () => {

  const {
    loader,
    setLoader,
    snackbarConfig,
    showSnackbar,
    closeSnackbar,
    dialogConfig,
    showDialog,
    closeDialog,
  } = useUiController();

  return (
    <SnpBaseLayout
      loader={loader}
      snackbarConfig={{ ...snackbarConfig, onClose: closeSnackbar }}
      dialogConfig={dialogConfig}
    >
      <RestoKeyboardQuickBill
        showSnackbar={showSnackbar}
        setSnpLoader={setLoader}
        snpLoader={loader}
        dialogConfig={dialogConfig}
        showDialog={showDialog}
        closeDialog={closeDialog}
      />

    </SnpBaseLayout>
  )
};

export default RestoKeyboardBase;